import React from 'react';

import './CircularProgressBar.styles.css';

export interface CircularProgressBarProps {
  label: number;
  percentage: number;
}

export const CircularProgressBar = ({ label, percentage }: CircularProgressBarProps) => {
  const hasTargetAchieved = React.useMemo(() => {
    return percentage === 100;
  }, [percentage]);
  const radius = 34;
  const strokeDasharray = radius * Math.PI * 2;

  const style = {
    fill: 'none',
    stroke: hasTargetAchieved ? '#5B68F6' : 'url(#gradientColor)',
    strokeWidth: '4px',
    strokeDasharray,
    strokeDashoffset: strokeDasharray - (strokeDasharray * percentage) / 100,
    transform: 'translate(2px, 2px)',
  };
  return (
    <div className={hasTargetAchieved ? 'cpbBoxFill cpbBox' : 'cpbBox'}>
      <div className="innerCircle">
        <div id="label-cpb">{label}%</div>
      </div>
      <svg id="svgCPB">
        <defs>
          <linearGradient id="gradientColor" x2="0%" y2="100%">
            <stop offset="0" stopColor="#32BB78" />
            <stop offset="0.7" stopColor="#5B68F6" />
          </linearGradient>
        </defs>
        <circle cx="36" cy="28" r={radius} className="progressCircle" style={style} />
      </svg>
    </div>
  );
};
